import { render, staticRenderFns } from "./SelectAddentity.vue?vue&type=template&id=32565dbe&scoped=true"
import script from "./SelectAddentity.vue?vue&type=script&lang=js"
export * from "./SelectAddentity.vue?vue&type=script&lang=js"
import style0 from "./SelectAddentity.vue?vue&type=style&index=0&id=32565dbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32565dbe",
  null
  
)

export default component.exports